<script lang="ts">
  import { currentDerivedWorkout, currentRawFirehose } from "./state";
  import { openOverlay } from "./overlay";
  import { haptic } from "./haptics";
  import { isRecentSwim, isDismissed, dismissSwim } from "./suspectsCardState";

  // dw.suspects is already resolution-filtered, so this count IS the unreviewed
  // queue. The PROMOTED card only appears on a RECENT, undismissed swim (offer,
  // never demand). Old or dismissed swims keep only the quiet in-context marker
  // that SetDetailSheet already renders per flagged length.
  let dw = $derived($currentDerivedWorkout);
  let count = $derived(dw?.suspects.length ?? 0);
  let uuid = $derived($currentRawFirehose?.workout.uuid ?? null);
  let swimDate = $derived($currentRawFirehose?.workout.startDate ?? null);
  // Local bump so a "Not now" tap re-evaluates `show` without a store round-trip.
  let dismissedTick = $state(0);
  let show = $derived(
    count > 0 &&
      uuid !== null &&
      swimDate !== null &&
      isRecentSwim(swimDate, Date.now()) &&
      dismissedTick >= 0 && // always true; reads dismissedTick to force recompute on "Not now"
      !isDismissed(uuid),
  );

  function review() {
    if (!dw || dw.suspects.length === 0) return;
    haptic("selection");
    openOverlay({ kind: "suspect-deck" });
  }

  function notNow() {
    if (!uuid) return;
    haptic("selection");
    dismissSwim(uuid);
    dismissedTick += 1; // re-run `show`
  }
</script>

{#if show}
  <div class="suspects-row">
    <button type="button" class="suspects-card" onclick={review}>
      <span class="suspects-count" aria-hidden="true">{count}</span>
      <span class="suspects-text">
        Quick check, about a minute: {count === 1 ? "1 length" : `${count} lengths`} to confirm
      </span>
      <span class="suspects-cta">Take a look ›</span>
    </button>
    <button type="button" class="suspects-dismiss" onclick={notNow}>Not now</button>
  </div>
{/if}

<style>
  .suspects-row {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }
  .suspects-card {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    min-height: 56px;
    margin: 0.75rem 0;
    padding: 0.85rem 1rem;
    background: var(--bg-card);
    color: var(--text-primary);
    border: 2px solid var(--accent-primary);
    border-radius: 12px;
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .suspects-count {
    flex: none;
    display: grid;
    place-items: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: var(--accent-primary);
    color: var(--bg-canvas);
    font-weight: 800;
  }
  .suspects-text { flex: 1; font-weight: 700; }
  .suspects-cta { flex: none; color: var(--accent-primary); font-weight: 700; }
  .suspects-dismiss {
    align-self: flex-end;
    min-height: 44px;
    padding: 0 0.75rem;
    background: none;
    border: 0;
    color: var(--text-muted);
    font-size: 0.9rem;
    font-weight: 700;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
</style>
